module.exports = __webpack_public_path__ + "static/media/techrobotix.b46ab329.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/client_logo/techrobotix.jpg
// module id = 161
// module chunks = 0